import { Dimensions, TextStyle } from "react-native";
import { Text } from "@towersystems/roam-common-native";

export interface DynamicMobileTextProps {
  label: string;
  alternativeMobileText?: string;
  textStyleProps?: TextStyle;
  mobileThreshold?: number;
}

const DEFAULT_MOBILE_THRESHOLD = 768;

export const DynamicMobileText = ({
  label,
  alternativeMobileText,
  textStyleProps,
  mobileThreshold = DEFAULT_MOBILE_THRESHOLD,
}: DynamicMobileTextProps) => {
  const windowWidth = Dimensions.get("window").width;

  if (windowWidth < mobileThreshold) {
    if (alternativeMobileText) {
      return (
        <Text variant="heading1" style={textStyleProps}>
          {alternativeMobileText}
        </Text>
      );
    } else {
      return null;
    }
  }

  return (
    <Text variant="heading1" style={textStyleProps}>
      {label}
    </Text>
  );
};
